import { useBooleanSetting } from "@faire/retailer-visitor-shared/settings/useBooleanSetting";
import { PRODUCT_TILE_FIRST_ITERATION_250421 } from "@faire/web-api--source/indigofair/settings/PRODUCT_TILE_FIRST_ITERATION_250421";

export const useSettingProductTileIteration = () =>
  useBooleanSetting(PRODUCT_TILE_FIRST_ITERATION_250421);
